export default function resolveTrainingCourseStatus(status) {
  if (status === 'PUBLIC') return { variant: 'success', text: 'Publiczne' }
  if (status === 'NON_PUBLIC') return { variant: 'dark', text: 'Niepubliczne' }
  return { variant: 'light', text: 'Nieznany' }
}
